import { filesService } from "@/services/files.service";
import Vue from "vue";

export const recurringDebit = {
  namespaced: true,
  state: {
    isDetailsDialogOpen: false,
    isUploadDialogOpen: false,
    isGenerateDialogOpen: false,
    fileSelected: [],
    files: [],
    totalFiles: 0,
    totalSubscriptions: 0,
    fileFormats: [],
    banks: [],
    subscription_statuses: [],
    filterFiles: [],
    totalFilter: 0
  },
  getters: {},
  actions: {
    async getFiles(
      { commit, rootState },
      { startDate, endDate, page, rowsPerPage }
    ) {
      const url = new URL("achgateway/files", this.$axios.defaults.baseURL);

      const params = {
        start_time: startDate,
        end_time: endDate,
        rowsPerPage,
        page
      };

      // Insert params into URL
      Object.keys(params).forEach(key =>
        url.searchParams.append(key, params[key])
      );

      try {
        const response = await this.$axios.get(url.toString());

        const { plain_files, total } = response.data;

        commit("setFiles", { plain_files, total });
      } catch (error) {
        Vue.noty.error(this.i18n.t("recurring_debit.messages.error_get_files"));
      }
    },
    async getFile({ commit, rootState }, payload) {
      const { startDate, endDate, search, page, rowsPerPage, id } = payload;

      const url = new URL(
        `achgateway/files/${id}`,
        this.$axios.defaults.baseURL
      );

      const params = {
        start_time: startDate,
        end_time: endDate,
        search,
        rowsPerPage,
        page
      };

      Object.keys(params).forEach(key =>
        url.searchParams.append(key, params[key])
      );

      try {
        const response = await this.$axios.get(url.toString());
        const { subscriptions, totalSubs } = response.data;
        commit("setFile", { subscriptions, totalSubs });
      } catch (error) {
        Vue.noty.error(this.i18n.t("recurring_debit.messages.error_get_file"));
      }
    },
    async getFilterFiles({ commit }, payload) {
      const {
        startDate = null,
        endDate = null,
        bank = null,
        subscription_status = null,
        billingGt = null,
        billingLt = null
      } = payload;
      try {
        const { subscriptions, total } = (
          await this.$axios.get(`achgateway/subscriptions`, {
            params: {
              bank_id: bank,
              subscription_status_id: subscription_status,
              start_time: startDate,
              end_time: endDate,
              billing_day_gte: billingGt,
              billing_day_lte: billingLt
            }
          })
        ).data;
        commit("setFilterFiles", { subscriptions, total });
        if (subscriptions.length > 0) {
          return { successData: true };
        } else {
          return { successData: false };
        }
      } catch (error) {
        return { error: false };
        // this.$toast.global.error(this.app.i18n.t('recurring_debit.messages.error_get_file'))
      }
    },
    async getBanks({ commit, rootState }) {
      try {
        const { data } = (await this.$axios.get(`achgateway/banks`)).data;
        commit("setBanks", data);
      } catch (error) {
        // this.$toast.global.error(this.app.i18n.t('recurring_debit.messages.error_banks'))
      }
    },
    async getFileFormats({ commit, rootState }) {
      try {
        const { data } = (await this.$axios.get(`achgateway/fileformats`)).data;
        commit("setFileFormats", data);
      } catch (error) {
        // this.$toast.global.error(this.app.i18n.t('recurring_debit.messages.error_file_formats'))
      }
    },
    async getSubscriptionStatuses({ commit, rootState }) {
      try {
        const { data } = (
          await this.$axios.get(`achgateway/subscription_statuses`)
        ).data;
        commit("setSubscriptionStatuses", data);
      } catch (error) {
        // this.$toast.global.error(this.app.i18n.t('recurring_debit.messages.error_subscription_statuses'))
      }
    },
    async generateFile({ _ }, payload) {
      try {
        await filesService.generateFiles(payload);
        Vue.noty.success(
          this.i18n.t("recurring_debit.messages.success_generate")
        );
      } catch (error) {
        Vue.noty.error(
          this.i18n.t("recurring_debit.messages.error_generate_file")
        );
      }
    },
    async uploadPlainFiles({ commit, rootState }, payload) {
      try {
        const response = (
          await this.$axios.post(`achgateway/files/upload`, payload)
        ).data;
        return response;
        // this.$toast.global.success(this.app.i18n.t('recurring_debit.messages.success_upload'))
      } catch (error) {
        // this.$toast.global.error(this.app.i18n.t('recurring_debit.messages.error_upload_file'))
      }
      return true;
    },
    async setAsTreated({ commit }, payload) {
      try {
        const { id } = payload;
        const response = await this.$axios.post(
          `achgateway/subscriptions/treated/${id}`
        ).data;
      } catch (error) {
        return false;
      }
    }
  },
  mutations: {
    openDetailsDialog(vuexState, transaction) {
      vuexState.isDetailsDialogOpen = true;
    },
    closeDetailsDialog(vuexState) {
      vuexState.isDetailsDialogOpen = false;
    },
    openUploadDialog(vuexState) {
      vuexState.isUploadDialogOpen = true;
    },
    closeUploadDialog(vuexState) {
      vuexState.isUploadDialogOpen = false;
    },
    openGenerateDialog(vuexState) {
      vuexState.isGenerateDialogOpen = true;
    },
    closeGenerateDialog(vuexState) {
      vuexState.isGenerateDialogOpen = false;
    },
    setFiles(vuexState, { plain_files, total }) {
      vuexState.files = plain_files;
      vuexState.totalFiles = total;
    },
    setFile(vuexState, { subscriptions, totalSubs }) {
      vuexState.fileSelected = subscriptions;
      vuexState.totalSubscriptions = totalSubs;
    },
    setBanks(vuexState, payload) {
      if (payload.length > 0) {
        const orden = payload.sort((a, b) =>
          a.attributes.name
            .toLowerCase()
            .localeCompare(b.attributes.name.toLowerCase())
        );
        const final = orden.map(element => ({
          name: element.attributes.name.toLowerCase(),
          id: element.id
        }));
        vuexState.banks = final;
      }
    },
    setFileFormats(vuexState, payload) {
      if (payload.length > 0) {
        const orden = payload.sort((a, b) =>
          a.attributes.name
            .toLowerCase()
            .localeCompare(b.attributes.name.toLowerCase())
        );
        const final = orden.map(element => ({
          name: element.attributes.name.toLowerCase(),
          id: element.id
        }));
        vuexState.fileFormats = final;
      }
    },
    setSubscriptionStatuses(vuexState, payload) {
      vuexState.subscription_statuses = payload;
    },
    setFilterFiles(vuexState, { subscriptions, total }) {
      vuexState.filterFiles = subscriptions;
      vuexState.totalFilter = total;
    }
  }
};
